import classNames from "classnames";

const CheckoutComponentFakeCheckout: React.FC = () => {
  return (
    <img
      src="/assets/checkout.webp"
      alt="Checkout"
      className={classNames("max-w-full", "mx-auto")}
    />
  );
};

export default CheckoutComponentFakeCheckout;
